import { post } from '../request'

//用户设置头像
export const UserSetAvatar = params =>post('/User/UserSetAvatarNew',params,{loading:true});

//机构设置logo
export const CompanySetLogo = params =>post('/User/CompanySetLogoNew',params,{loading:true});
